var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrap"},[_c('p',{staticClass:"px-0 my-auto",class:_vm.$vuetify.breakpoint.xs ? 'text-right' : 'text-left'},[_vm._v(" "+_vm._s(_vm.item.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }